"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("min-width:", (0, _util.rem)(185), ";color:", theme.color.monochrome.black, ";border-radius:", (0, _util.rem)(8), ";box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.25);[role='menuitem']{padding-left:", (0, _util.rem)(14), ";padding-right:", (0, _util.rem)(14), ";&[tabindex='0']:hover,&.highlighted{background-color:", theme.color.monochrome.superLight, "!important;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var status = function status(theme) {
  return /*#__PURE__*/(0, _react.css)("&::before{display:block;content:'';position:absolute;top:-3px;right:-3px;border:solid 2px ", theme.color.globalNav.noticeCountColor, ";border-radius:50%;width:", (0, _util.rem)(10), ";height:", (0, _util.rem)(10), ";z-index:3;}" + (process.env.NODE_ENV === "production" ? "" : ";label:status;"));
};

var online = function online(theme) {
  return /*#__PURE__*/(0, _react.css)(status(theme), ";&::before{background-color:", theme.color.status.online, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:online;"));
};

var away = function away(theme) {
  return /*#__PURE__*/(0, _react.css)(status(theme), ";&::before{background-color:", theme.color.status.away, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:away;"));
};

var offline = function offline(theme) {
  return /*#__PURE__*/(0, _react.css)(status(theme), ";&::before{background-color:", theme.color.status.offline, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:offline;"));
};

var out = function out(theme) {
  return /*#__PURE__*/(0, _react.css)(status(theme), ";&::before{background-color:", theme.color.status.out, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:out;"));
};

var statuses = {
  online: online,
  away: away,
  offline: offline,
  out: out
};
var styles = {
  base: base,
  statuses: statuses
};
exports.styles = styles;
//# sourceMappingURL=UserItem.styles.js.map